import React from "react";
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer
} from "@paypal/react-paypal-js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PaypalButtonComponent = ({ onSuccess, onError }) => {
  const [{ isPending, isRejected }] = usePayPalScriptReducer();

  // ✅ 1. Create Vault Setup Token
  const getSetupToken = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/customer_token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("logged_user_id"),
            context: "paypal_vault"
          })
        }
      );

      const data = await res.json();
      if (!data.success)
        throw new Error(data.message || "Failed to get setup token");

      return data.data.id; // ✅ returning setup token
    } catch (error) {
      console.error("Setup token error:", error);
      console.log("Failed to initialize PayPal setup");
      throw error;
    }
  };

  // ✅ 2. Use vaultSetupToken dynamically here
  const handleApprove = async ({ vaultSetupToken }) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/create_payment_token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: JSON.stringify({
            setup_token: vaultSetupToken,
            user_id: localStorage.getItem("logged_user_id")
          })
        }
      );

      const result = await res.json();
      console.log("🔍 Response from create_payment_token:", result);

      // ✅ Adjusted to match your API's actual response
     if (!result?.success || !result?.token_id) {
  console.error("Unexpected server response:", result);
  return; // yaha bas exit kar do, user ko kuch mat dikhao
}


      console.log("✅ Payment method saved successfully!");
      onSuccess?.(); // Optional callback
    } catch (err) {
      console.error("❌ Payment token error:", err);
      console.log(err.message || "❌ Failed to save payment method");
      onError?.(err);
    }
  };

  if (isRejected)
    return (
      <Typography color="error" align="center">
        Failed to load PayPal.
      </Typography>
    );

  if (isPending)
    return <Typography align="center">Loading PayPal button...</Typography>;

  return (
    <PayPalButtons
      fundingSource="paypal"
      style={{
        layout: "vertical",
        shape: "pill",
        label: "paypal",
        height: 45,
        disableMaxWidth: true
      }}
      createVaultSetupToken={getSetupToken}
      onApprove={handleApprove}
      onCancel={() => console.log("Setup cancelled")}
      onError={(err) => {
        console.error("PayPal error:", err);
        console.log("PayPal error occurred");
        onError?.(err);
      }}
    />
  );
};

export default function PaypalVaultSection({ onPaymentSaved, onError }) {
  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "USD",
    components: "buttons",
    vault: true,
    intent: "capture",
    disableFunding: "card"
  };

  return (
    <Box mt={2}>
      <PayPalScriptProvider options={initialOptions}>
        <PaypalButtonComponent
          onSuccess={onPaymentSaved}
          onError={onError}
        />
      </PayPalScriptProvider>
    </Box>
  );
}